//   数据埋点请求
import request from '@/utils/requestStatistics'
import { getLogin } from '@/utils/auth' // 获取url参数
import { getUrlKey, checkWx } from '@/utils/index' // 获取url参数

// 访问记录
export function visit(w_title, activity_id) {
  request({
    url: 'Analyzes/index/Session',
    method: 'post',
    data: {
      o_id: getLogin(),
      w_code: getUrlKey('WxKey') || '', // 微信公众号唯一标识【必填】
      c_code: getUrlKey('income') || '', // 渠道唯一标识【选填】
      s_id: getSession(), // 会话id【必填】
      v_id: getLogin() ? '' : getTemporaryId()
    }
  }).then(res => {
    return request({
      url: 'Analyzes/index/Visit',
      method: 'post',
      data: {
        o_id: getLogin(),
        a_id: activity_id,
        w_title: w_title,
        c_code: getUrlKey('income') || '', // 渠道唯一标识【选填】
        w_url: window.location.href,
        s_id: getSession(), // 会话id【必填】
        v_id: getLogin() ? '' : getTemporaryId()
      }
    })
  })
}

// 事件记录统计
export function eventRecord(event) {
  request({
    url: 'Analyzes/index/Session',
    method: 'post',
    data: {
      o_id: getLogin(),
      w_code: getUrlKey('WxKey') || '', // 微信公众号唯一标识【必填】
      c_code: getUrlKey('income') || '', // 渠道唯一标识【选填】
      s_id: getSession(), // 会话id【必填】
      v_id: checkWx() ? '' : getTemporaryId()
    }
  }).then(res => {
    return request({
      url: 'Analyzes/index/Event',
      method: 'post',
      data: {
        o_id: getLogin(),
        e_code: event,
        w_url: window.location.href,
        c_code: getUrlKey('income') || '', // 渠道唯一标识【选填】
        s_id: getSession(), // 会话id【必填】
        v_id: checkWx() ? '' : getTemporaryId()
      }
    })
  })
}

// 生成回话id
function getSession() {
  var serial = Date.parse(new Date()) / 1000
  var session = ''
  if (getLogin()) {
    session = getLogin() + '_' + serial
  } else {
    session = getTemporaryId() + '_' + serial
  }
  if (sessionStorage.getItem('sessionId')) {
    return sessionStorage.getItem('sessionId')
  } else {
    sessionStorage.setItem('sessionId', session)
    return session
  }
}

// 生成临时id
function getTemporaryId() {
  var arr = ''
  for (let i = 0; i < 8; i++) {
    const a = Math.random() * 9 + 1
    arr = arr + (Math.floor(a).toString())
  }
  if (sessionStorage.getItem('temporaryId')) {
    console.log('拥有temporaryId')
    return sessionStorage.getItem('temporaryId')
  } else {
    console.log('没有temporaryId')
    sessionStorage.setItem('temporaryId', arr)
    return arr
  }
}

// 调用百度
export function baidu() {
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement('script')
    hm.src = 'https://hm.baidu.com/hm.js?48129afbb09716083acae0ce8b3fedf5'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
  })()
}

// 知乎
export function zhihu() {
  (function(root) {
    window.zhad = []
    var tag = document.createElement('script'); tag.type = 'text/javascript'; tag.async = true
    tag.src = '//unpkg.zhimg.com/@efe/zhad-tracker@1.4.1'
    tag.onerror = function() {
      var img = new Image()
      img.src = '//sugar.zhihu.com/log_fe?js_url=' + window.encodeURIComponent(tag.src) + '&t=' + (+new Date())
    }
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(tag, s)
  })()
}

// b站
export function bilibili() {
  const _hmt = _hmt || [];
  (function() {
    var hm = document.createElement('script')
    hm.src = 'https://s1.hdslb.com/bfs/cm/cm-sdk/static/js/track-collect.js'
    var s = document.getElementsByTagName('head')[0]
    s.parentNode.insertBefore(hm, s)
  })()
}

// 腾讯
export function tencent() {
  /* eslint-disable */
  !function(g,d,t,e,v,n,s){if(g.gdt)return;v=g.gdt=function(){v.tk?v.tk.apply(v,arguments):v.queue.push(arguments)};v.sv='1.0';v.bt=0;v.queue=[];n=d.createElement(t);n.async=!0; n.src=e;s=d.getElementsByTagName(t)[0];s.parentNode.insertBefore(n,s);}(window,document,'script', '//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js');gdt('init','1200261702');gdt('track','PAGE_VIEW');
  var noscript = document.createElement("noscript");
  var img = document.createElement("img");
  img.height = '1'
  img.width = '1'
  img.style = 'display:none'
  img.src = 'https://a.gdt.qq.com/pixel?user_action_set_id=1200261702&action_type=PAGE_VIEW&noscript=1'
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

// 针对支付H5的腾讯投放API
export function tencentPay() {
  /* eslint-disable */
  !function(g,d,t,e,v,n,s){if(g.gdt)return;v=g.gdt=function(){v.tk?v.tk.apply(v,arguments):v.queue.push(arguments)};v.sv='1.0';v.bt=0;v.queue=[];n=d.createElement(t);n.async=!0;n.src=e;s=d.getElementsByTagName(t)[0];s.parentNode.insertBefore(n,s);}(window,document,'script','//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js');
  gdt('init','1200607005');
  gdt('track','PAGE_VIEW');
  var noscript = document.createElement("noscript");
  var img = document.createElement("img");
  img.height = '1'
  img.width = '1'
  img.style = 'display:none'
  img.src = 'https://a.gdt.qq.com/pixel?user_action_set_id=1200607005&action_type=PAGE_VIEW&noscript=1'
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

// 腾讯事件记录
export function setTencentTrack(name, obj = {}) {
  // gdt('track', 'VIEW_CONTENT');// 浏览
  // gdt('track', 'RESERVATION');// 预约
  gdt('track', name, obj)// 预约
}

// 针对抖音投放的API
export function TikTok() {
  /* eslint-disable */
    (function(r,d,s){r._tt_config=true;var _baq=(r._baq=r._baq||[]);_baq.methods=["track","off","on"];
    _baq.factory=function(method){return function(){var args=Array.prototype.slice.call(arguments);
    args.unshift(method);_baq.push(args);return _baq}};for(var i=0;i<_baq.methods.length;i++){
    var key=_baq.methods[i];_baq[key]=_baq.factory(key)}_baq.load=function(){
    var js,fjs=d.getElementsByTagName(s)[0];js=d.createElement(s);
    js.src="https://analytics.oceanengine.com/api/v2/js/sdk";fjs.parentNode.insertBefore(js,fjs)};
    _baq.load();if(_baq.invoked){return}_baq.invoked=true;_baq.track("pageview")})(window,document,"script");
}

// 抖音事件记录
export function setTikTokTrack() {
  _baq.track("form", { assets_id: '1737394338091019' })
}
